import type { Maybe } from '@adornis/base/utilTypes.js';

export enum Taetigkeiten {
  BETREUUNGSKRAFT = 'Betreuungskraft',
  BUCHHALTUNG = 'Buchhaltung',
  FSJ = 'FSJ',
  HAUSHALTSKRAFT = 'Haushaltskraft',
  HAUSMEISTER = 'Hausmeister',
  HILFSKRAFT = 'Hilfskraft',
  KÜCHENKRAFT = 'Küchenkraft',
  KÜCHENLEITUNG = 'Küchenleitung',
  LEHRKRAFT = 'Lehrkraft',
  PÄDAGOGISCHE_FACHKRAFT = 'Pädagogische Fachkraft',
  REINIGUNGSKRAFT = 'Reinigungskraft',
  SCHULLEITUNG = 'Schulleitung',
  SCHULPASTORAL = 'Schulpastoral',
  SEKRETÄRIATSKRAFT = 'Sekretäriatskraft',
  SOZIALPÄDAGOGISCHE_FACHKRAFT = 'Sozialpädagogische Fachkraft',
  VERWALTUNGSKRAFT = 'Verwaltungskraft',
  VERWALTUNGSLEITUNG = 'Verwaltungsleitung',
  KAUFMÄNNISCHE_FACHKRAFT = 'kaufmännische Fachkraft',
  PRAKTIKANT = 'Praktikant',
  GESCHÄFTSFÜHRUNG = 'Geschäftsführung',
  BIBLIOTHEK = 'Bibliothek',
  PFORTE = 'Pforte',
  FERIENBETREUUNG = 'Ferienbetreuung',
  AG_DURCHFUEHRENDER = 'AG Durchführender',
}

// TODO we should migrate taetigkeiten to be in the TaetigkeitsBaseData format. just for quick testing purposes we return a quick test code here
export function getTaetigkeitsTestIdentifikationscode(taetigkeit: string): string {
  if (taetigkeit === Taetigkeiten.LEHRKRAFT) return '84124';
  if (taetigkeit === Taetigkeiten.BETREUUNGSKRAFT) return '83111';
  if (taetigkeit === Taetigkeiten.VERWALTUNGSKRAFT) return '71402';
  if (taetigkeit === Taetigkeiten.KÜCHENKRAFT) return '29301';
  if (taetigkeit === Taetigkeiten.REINIGUNGSKRAFT) return '54101';
  if (taetigkeit === Taetigkeiten.SEKRETÄRIATSKRAFT) return '71402';
  if (taetigkeit === Taetigkeiten.PÄDAGOGISCHE_FACHKRAFT) return '83113';
  if (taetigkeit === Taetigkeiten.HILFSKRAFT) return '84304';
  if (taetigkeit === Taetigkeiten.SCHULLEITUNG) return '84124';
  if (taetigkeit === Taetigkeiten.BIBLIOTHEK) return '73324';
  if (taetigkeit === Taetigkeiten.HAUSMEISTER) return '34102';
  if (taetigkeit === Taetigkeiten.AG_DURCHFUEHRENDER) return '83121';
  return '99999';
}

export type Taetigkeit = (typeof Taetigkeiten)[keyof typeof Taetigkeiten];

/**
 * Checks if the given taetigkeit is a Lehrkrafttätigkeit. Lehrkraft in this sense means, someone is actively teaching.
 * @param taetigkeit a Taetigkeit entity from a contract, using the abstract class here as it is the common base class for all Taetigkeiten
 * @returns true if the taetigkeit is a Lehrkrafttätigkeit
 */
export function isLehrkraft(taetigkeit: Maybe<Taetigkeit>): boolean {
  if (!taetigkeit) return false;
  return (
    taetigkeit === Taetigkeiten.LEHRKRAFT ||
    taetigkeit === Taetigkeiten.PÄDAGOGISCHE_FACHKRAFT ||
    taetigkeit === Taetigkeiten.SCHULLEITUNG
  );
}
